
/**
 * Represents the risk classes.
 * @author mukesh.kumar@vernuso.com (Mukesh Kumar)
 */
export enum RiskClass {
    LOW = <any>'Low',
    MEDIUM = <any>'Medium',
    HIGH = <any>'High',
}



// WEBPACK FOOTER //
// ./src/app/shared/models/risk-class.enums.ts